import type { RefObject } from "react";
import {
  MeshDepthMaterial,
  RGBADepthPacking,
  type Mesh,
  type Texture,
  type WebGLProgramParametersWithUniforms,
} from "three";
import depthMainVert from "../shaders/depth_main.vert";
import depthParsFrag from "../shaders/depth_pars.frag";
import depthParsVert from "../shaders/depth_pars.vert";
import dissolveMainFrag from "../shaders/dissolve_main.frag";

export const addShadow = (
  child: Mesh,
  currentUseDissolveValue: boolean,
  dissolveTexture: Texture,
  depthShaderRef: RefObject<WebGLProgramParametersWithUniforms | null>,
) => {
  const mat = new MeshDepthMaterial({
    depthPacking: RGBADepthPacking,
  });
  mat.onBeforeCompile = (shader) => {
    shader.defines = {
      ...shader.defines,
      ...(currentUseDissolveValue && {
        USE_DISSOLVE: "",
      }),
    };
    shader.uniforms = {
      ...shader.uniforms,
      dissolveTexture: { value: dissolveTexture },
      dissolveValue: { value: 0.0 },
      lastEvent: { value: 0 },
      lastEventTime: { value: 0.0 },
      iGlobalTime: { value: 0.0 },
    };
    const clippingPlanesPars = "#include <clipping_planes_pars_vertex>";
    shader.vertexShader = shader.vertexShader.replace(
      clippingPlanesPars,
      `${clippingPlanesPars}
            ${depthParsVert}`,
    );
    const clippingPlanes = "#include <clipping_planes_vertex>";
    shader.vertexShader = shader.vertexShader.replace(
      clippingPlanes,
      `${clippingPlanes}
            ${depthMainVert}`,
    );
    const closedCurlyBrace = "}";
    shader.fragmentShader = shader.fragmentShader.replace(
      closedCurlyBrace,
      `${dissolveMainFrag}
            }`,
    );
    const clippingPlanesParsFrag = "#include <clipping_planes_pars_fragment>";
    shader.fragmentShader = shader.fragmentShader.replace(
      clippingPlanesParsFrag,
      `${clippingPlanesParsFrag}
            ${depthParsFrag}`,
    );
    depthShaderRef.current = shader;
  };

  child.customDepthMaterial = mat;
};
